<template>
  <div style="height:100%; width:100%;">
    <div class="heaDateControl">
      <el-date-picker
        v-model="value1"
        type="week"
        :change="changeDate()"
        :format="
          this.startDate + '  ' + '至' + '  ' + this.endDate + '  ' + '第WW周'
        "
        placeholder="选择周"
      >
      </el-date-picker>
    </div>
    <div class="EchartsControl">
      <div class="ontology" id="myChart"></div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import * as echarts from "echarts";

export default {
  name: "bubblEchart",
  props: ["totliId", "startTime", "endTime"],
  data() {
    return {
      tableData: [],
      startDate: this.startTime,
      endDate: this.endTime,
      value1: "",
      scatterData: [],
      numOfDay: []
    };
  },
  methods: {
    //周转换方法——dayjs插件
    changeDate() {
      if (
        dayjs(this.value1)
          .startOf("week")
          .format("YYYY-MM-DD") != "Invalid Date"
      ) {
        this.startDate = dayjs(this.value1)
          .startOf("week")
          .format("YYYY-MM-DD");
        this.endDate = dayjs(this.value1)
          .endOf("week")
          .format("YYYY-MM-DD");
      }
      this.getRecordCount();
    },

    //接口获取数据——filter后获取当前周抽纸统计数据
    getTotilPerpo() {
      this.get("/outPaper/getList", {}).then(res => {
        this.tableData = res.data.data;
      });
    },

    //调用接口获取选择周的参数
    getRecordCount() {
      let arrFilter = this.tableData.filter(
        ele => ele.toilet_id === this.totliId
      );
      if (arrFilter != "") {
        this.get("/outPaper/recordCount", {
          sbh: arrFilter[0].ser_num,
          beginTime: this.startDate,
          endTime: this.endDate
        }).then(res => {
          this.drawLine(res.data.data);
        });
      }
    },

    getWeek(dateString) {
      let dateArray = dateString.split("-");
      let date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },

    drawLine(sourceData) {
      let days = [];
      let data = [];

      for (let i = 0; i < sourceData.length; i++) {
        //获取拥有的星期数
        days.push(this.getWeek(sourceData[i].date));
        //获取当前星期下的使用次数和时间
        sourceData[i].countList.forEach(item => {
          //根据当前星期排序拼接完成所需数据结构
          data.push([
            days.indexOf(this.getWeek(sourceData[i].date)),
            item.hour,
            item.num
          ]);
        });
      }
      let myChart = echarts.init(document.getElementById("myChart"));
      const hours = [
        "24",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ];

      // 绘制图表
      myChart.setOption({
        title: {
          text: "出纸机每日使用次数统计"
        },
        legend: {
          data: ["次数"],
          left: "right",
          textStyle: {
            color: "#8080ff"
          },
          itemStyle: {
            color: "#8080ff"
          }
        },
        polar: {},
        tooltip: {
          backgroundColor: "rgba(1,70,86,1)",
          borderColor: "rgba(0,246,255,1)",

          axisPointer: {
            type: "cross"
          },
          formatter: function(params) {
            return (
              '<span style="color: #02DBF1;">' +
              "星期：" +
              days[params.value[0]] +
              "</span>" +
              "</br>" +
              '<span style="color: #02DBF1;">' +
              "时间：" +
              hours[params.value[1]] +
              "点" +
              "</span>" +
              "</br>" +
              '<span style="color: #02DBF1;">' +
              "次数：" +
              params.value[2] +
              "次" +
              "</span>" +
              "</br>"
            );
          }
        },
        angleAxis: {
          type: "category",
          data: hours,
          boundaryGap: false,
          // splitLine: {
          //   show: true
          // },
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            interval: 0,
            lineStyle: {
              color: "#333",
              width: "1"
            }
          }
        },
        radiusAxis: {
          type: "category",
          data: days,
          axisLine: {
            show: true
          },
          axisLabel: {
            rotate: 45
          },
          splitLine: {
            show: true,
            interval: 0,
            lineStyle: {
              color: "#333",
              width: "1"
            }
          },
          axisTick: {
            show: true,
            length: 5,
            alignWithLabel: false,
            inside: false
          },
          textStyle: {
            color: "#ff8533"
          }
        },
        series: [
          {
            name: "次数",
            type: "scatter",
            coordinateSystem: "polar",
            textStyle: {
              color: "#8080ff"
            },
            itemStyle: {
              color: "#8080ff"
            },
            symbolSize: function(val) {
              return val[2] * 6;
            },
            data: data,
            animationDelay: function(idx) {
              return idx * 5;
            }
          }
        ]
      });
      window.οnresize = function() {
        myChart.resize();
      };
    },

    //监听事件父组件参数"startTime"并赋值
    parentCptStime() {
      this.$watch(
        "startTime",
        val => {
          this.startDate = val;
        },
        {
          deep: true
        }
      );
    },
    //监听事件父组件参数"endTime"并赋值
    parentCptEtime() {
      this.$watch(
        "endTime",
        val => {
          this.endDate = val;
        },
        {
          deep: true
        }
      );
    }
  },
  mounted() {
    this.getTotilPerpo();
    this.getRecordCount();
  },
  created() {
    this.parentCptStime();
    this.parentCptEtime();
  },
  destroyed() {
    //销毁开始结束事件的默认值
    window.removeEventListener(
      this.parentCptStime(),
      this.parentCptEtime(),
      true
    );
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-input--suffix .el-input__inner {
  width: 450px !important;
  background-color: #0c284e;
  border: none;
  color: #fff;
  font-size: 20px;
  border: 2px solid rgb(69, 162, 255);
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 450px;
}
.heaDateControl {
  width: 100%;
  height: 10%;
}
.EchartsControl {
  width: calc(100% - 20px);
  height: calc(90% - 20px);
}
.ontology {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/html/bubblEchartcontainer.vue